import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '=',
        form: '='
    },
    template: `
        <!--<h2 class="todo">MAGNUM OÜ</h2>-->
        <form role="form" class="form">
            <form-wrapper form="vm.form">
                <privileges-selection form="vm.form" privileges="vm.privileges"/>
            </form-wrapper>
            <ul class="actions01">
                <li><button ng-click="vm.save()" class="btn main">{{ 'general.Save changes' | translate }}</button></li>
            </ul>
        </form>
    `
})
export default class {
    constructor (lodash, ROLE_COMPANY_PRIVILEGE_ENUM, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM, ROLE_SPECIAL_PRIVILEGE_ENUM,
                 UserAssignmentResource, TokenService) {
        this.lodash = lodash;
        this.privileges = ROLE_COMPANY_PRIVILEGE_ENUM.LABELS;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.ROLE_SPECIAL_PRIVILEGE_ENUM = ROLE_SPECIAL_PRIVILEGE_ENUM;
        this.UserAssignmentResource = UserAssignmentResource;
        this.TokenService = TokenService;
    }

    $onInit () {
        this.form.model.privileges = this.lodash.filter(this.form.model.privileges, (privilege) => {
            return this.lodash.has(this.privileges, privilege);
        });
    }

    save () {
        this.UserAssignmentResource.setCompanyPrivileges({ id: this.user.id }, this.form.model).$promise
        .then(() => {
            this.form.saved = true;
        })
        .catch(() => {
            this.form.invalid = true;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/users/detail/company/index.js